<script context="module">
	import { Link } from 'svelte-routing'
    import { ShowCoffeeModal } from '../../script/_init'
</script>

<header>
    <div class="left">
        <Link to="/">
            <img src="/img/logo.png" alt="">
        </Link>
        <Link to="/">
            던전 스쿼드 팀 빌딩
        </Link>
    </div>

    <div class="right" >
        <Link to="/bookmark">
            북마크
        </Link>
        <div on:click={() => ShowCoffeeModal.set(!($ShowCoffeeModal))}>
            커피한잔후원
        </div>
    </div>
</header>

<style lang="scss">
    header {
        background: $cl3;
        width: calc(100% - 30px);
        height: fit-content;
        margin-bottom: 20px;
        padding: 15px;

        display: flex;
        justify-content: space-between;
        align-items: center;

        .right {
            color: $cl1;
            font-size: 24px;
            text-decoration: none;
            font-family: aggro;
            vertical-align: middle;
            display: flex;
            cursor: pointer;

            :global(a) {
                margin: 0 10px;
                color: $cl1;
                font-size: 24px;
                text-decoration: none;
                font-family: aggro;
                vertical-align: middle;
                cursor: pointer;

                @include mobile {
                    font-size: 14px;
                }
            }

            @include mobile {
                font-size: 14px;
            }
        }

        @include mobile {
            :global(a) {
                color: $cl1;
                font-size: 24px;
                text-decoration: none;
                font-family: aggro;
                vertical-align: middle;
            }

            img {
                height: 24px;
                vertical-align: middle;
                margin-right: 10px;
            }
        }

        @include tablet {
            :global(a) {
                color: $cl1;
                font-size: 30px;
                text-decoration: none;
                font-family: aggro;
                vertical-align: middle;
            }

            img {
                height: 30px;
                vertical-align: middle;
                margin-right: 14px;
            }
        }

        @include desktop {
            :global(a) {
                color: $cl1;
                font-size: 50px;
                text-decoration: none;
                font-family: aggro;
                vertical-align: middle;
            }

            img {
                height: 50px;
                vertical-align: middle;
                margin-right: 20px;
            }
        }

        @include wide {
            :global(a) {
                color: $cl1;
                font-size: 50px;
                text-decoration: none;
                font-family: aggro;
                vertical-align: middle;
            }

            img {
                height: 50px;
                vertical-align: middle;
                margin-right: 20px;
            }
        }
    }
</style>



